import React from 'react'
import _ from 'lodash'

import Config from '../../../../config'
import VariableMainRendering from '../../../Variables/Function/VariableMainRendering'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

export default function DisplayImageAttribute({
  stationData,
  attributeData,
  diagramData,
  display,
}) {
  let type = diagramData?.diagramTypeImage
  //console.log('attribule', attributeData.dataSource, attributeData)
  if (
    attributeData?.dataSource === Config.TypeOfSource.GaugeSource.sensor &&
    display === false
  ) {
    const sensorSourceData = _.find(
      stationData?.sensors,
      (sensor) => sensor.refString === attributeData.sensorRef
    )
    // console.log('sensorSourceData', sensorSourceData, attributeData)
    if (sensorSourceData) {
      if (attributeData.isActiveHigh === true) {
        return sensorSourceData.booleanStatus === true ? (
          <img
            src={`/images/${type}/On` + diagramData.diagramImage}
            alt={diagramData.diagramName}
            //className={`w-${displaySize} h-20 self-end `}
            className="w-full h-full"
          />
        ) : (
          <img
            src={`/images/${type}/Off` + diagramData.diagramImage}
            alt={diagramData.diagramName}
            className="w-full h-full"
          />
        )
      } else {
        return (
          <div>
            {sensorSourceData.booleanStatus === false ? (
              <img
                src={`/images/${type}/Off` + diagramData.diagramImage}
                alt={diagramData.diagramName}
                className="w-full h-full"
              />
            ) : (
              <img
                src={`/images/${type}/On` + diagramData.diagramImage}
                alt={diagramData.diagramName}
                className="w-full h-full"
              />
            )}
          </div>
        )
      }
    } else {
      return <div></div>
    }
  } else if (
    attributeData?.dataSource === Config?.TypeOfSource?.GaugeSource?.variable
  ) {
    const variableData = VariableMainRendering(
      stationData,
      attributeData?.variableId
    )
    if (attributeData?.isActiveHigh === true) {
      return (
        <div>
          {variableData === true ? (
            <img
              src={`/images/${type}/On` + diagramData.diagramImage}
              alt={diagramData.diagramName}
              className="w-full h-full"
            />
          ) : (
            <img
              src={`/images/${type}/Off` + diagramData.diagramImage}
              alt={diagramData.diagramName}
              className="w-full h-full"
            />
          )}
        </div>
      )
    } else {
      return (
        <div>
          {variableData === false ? (
            <img
              src={`/images/${type}/Off` + diagramData.diagramImage}
              alt={diagramData.diagramName}
              className="w-full h-full"
            />
          ) : (
            <img
              src={`/images/${type}/On` + diagramData.diagramImage}
              alt={diagramData.diagramName}
              className="w-full h-full"
            />
          )}
        </div>
      )
    }
  } else {
    return display === true ? (
      <img
        src={`/images/${type}/` + diagramData.diagramImage}
        alt={diagramData.diagramName}
        className="w-full h-full"
      />
    ) : (
      <img
        src={`/images/${type}/` + diagramData.diagramImage}
        alt={diagramData.diagramName}
        className="w-full h-full"
      />
    )
  }
}
